import { useNavigate, useParams } from "react-router-dom";
import ClientLayout from "../../components/Layout/ClientLayout";
import HikingTimeline from "./Timeline";
import {
  useGetProgrammesDetailQuery,
  useGetProgrammesQuery,
} from "../../apiCaller/apis/getApi";
import { GetTableListAPI } from "../../apiCaller/getAPIsCaller";
import HtmlContent from "../../utils/DisplayHTML";
import { useEffect, useState } from "react";
import PriceTable from "../Event/priceTable";
import PaymentPlan from "./PaymentPlan";
import DateFormatterComponent from "../../utils/DateFormatterComponent";
import { MdCalendarMonth } from "react-icons/md";
import { SlClock } from "react-icons/sl";
import ButtonComponent from "../../components/button/Button";
import ProgrammeComponent from "../../components/eventCard/ProgrammeComponent";
import PaymentPlan2 from "./PaymentPlan2";
import PriceComparisonTable from "./PriceComparison";
import PriceGridCards from "./PriceComparison";
import PaymentProgress from "./PaymentPlan2";

const ProgrammeDetail = () => {
  const [priceData, setPriceData] = useState();
  const [paymentPlanData, setPaymentPlanData] = useState([]);
  const navigate = useNavigate();
  const { programmeId } = useParams();
  const {
    data: programmes,
    error: programmesError,
    isLoading: programmesIsLoading,
    isFetching: programmesIsFetching,
  } = GetTableListAPI({}, useGetProgrammesQuery);
  const {
    data: programme,
    error: programmeError,
    isLoading: programmeIsLoading,
    isFetching: programmeIsFetching,
  } = GetTableListAPI(
    { programmeId: programmeId },
    useGetProgrammesDetailQuery
  );

  useEffect(() => {
    if (programme !== undefined && programme?.Value?.price?.length > 0) {
      let pricesModel = [];
      console.log(programme?.Value?.price);
      if (
        programme?.Value?.price === undefined ||
        !Array.isArray(programme?.Value?.price) ||
        programme.Value.price.length === 0
      ) {
        return;
      }
      

      const transformedData =  transformTieredData(programme?.Value?.price);
      console.log(transformedData);
      setPriceData(transformedData);
      
    }

    if (programme !== undefined && programme?.Value?.paymentPlan?.length > 0) {
      let pPlans = [];
      programme?.Value?.paymentPlan.forEach((plan) => {
        pPlans.push({
          installment: plan.Installment,
          percentage: plan.Percentage,
        });
      });

      setPaymentPlanData(pPlans);
    }
  }, [programme]);

  
  const transformTieredData = (data) =>{
    console.log(data)
    const result = {};

    data.forEach((tier) => {
      const tierName = tier.name;

      if(tier.priceGroups === undefined || !Array.isArray(tier.priceGroups)){
        return {};
      }
      tier.priceGroups.forEach((pg) => {
        if (!result[pg.group]) {
          result[pg.group] = {};
        }

        result[pg.group][tierName] = {
          amount: pg.amount,
          currency: pg.currency,
        };
      });
    });

    return result;
  }

  console.log(priceData)
  return (
    <ClientLayout>
      <div className="px-10 md:px-16 lg:px-24">
        {/* HERO COMPONENT */}
        <div className="relative w-full h-[300px] lg:h-[400px]">
          <div class="absolute inset-0 bg-color-primary-dark2 opacity-30"></div>
          <img
            src={programme?.Value?.displayImageUrl}
            alt="Main View"
            className="w-full h-full object-cover rounded-lg"
          />

          <div className="absolute left-[40%] top-[40%]">
            <div className="text-5xl lg:text-7xl text-white font-bold">
              {programme?.Value?.name}
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row space-x-0 lg:space-x-24 space-y-5 lg:space-y-0 my-16 mx-0 lg:mx-10 w-full">
          {/* DESCRIPTION */}
          <div className="flex-[2]">
            <div className="font-semibold text-4xl my-5 text-color-primary-dark2">
              Learn about {programme?.Value?.name}
            </div>
            <div className="my-10 tracking-wide leading-[2]">
              <HtmlContent htmlData={programme?.Value?.description} />
              {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum. */}
            </div>

            <div className="flex flex-col lg:flex-row space-y-5 lg:space-y-0 items-center my-10">
              <div className="flex-1 w-full border-[1px] px-10 py-5">
                <div className="flex items-center space-x-3">
                  {/* ICON */}
                  <div>
                    <MdCalendarMonth color="#201F5B" />
                  </div>
                  {/* TITLE */}
                  <div className="font-semibold text-color-primary-dark2">
                    Start Date
                  </div>
                </div>

                <div>
                  <DateFormatterComponent date={programme?.Value?.startDate} />
                </div>
              </div>
              <div className="flex-1 w-full border-[1px] px-10 py-5">
                <div className="flex items-center space-x-3">
                  {/* ICON */}
                  <div>
                    <MdCalendarMonth color="#201F5B" />
                  </div>
                  {/* TITLE */}
                  <div className="font-semibold text-color-primary-dark2">
                    End Date
                  </div>
                </div>

                <div>
                  <DateFormatterComponent date={programme?.Value?.endDate} />
                </div>
              </div>

              <div className="flex-1 w-full border-[1px] px-10 py-5">
                <div className="flex items-center space-x-3">
                  {/* ICON */}
                  <div>
                    <SlClock color="#201F5B" />
                  </div>
                  {/* TITLE */}
                  <div className="font-semibold text-color-primary-dark2">
                    Duration
                  </div>
                </div>

                <div>
                  {programme?.Value?.duration} {programme?.Value?.durationUnits}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-custom-image bg-cover bg-center rounded-lg relative w-full py-16">
          {/* Background overlay with lower z-index */}
          <div className="absolute inset-0 bg-[#F0F0F0] opacity-90 z-0"></div>
          <div className="flex flex-col lg:flex-row items-center lg:items-start justify-between relative z-10">
            <div className="flex-[1.5] relative z-10">
              <div className="text-center text-5xl font-semibold my-16">
                {programme?.Value?.name} Schedule
              </div>

              <div className="w-[90%] mx-auto">
                <HikingTimeline
                  adventures={programme?.Value?.programmeAdventures}
                />
              </div>
            </div>

            <div className="flex-1 bg-[#F0F0F0] px-10 pt-10 pb-24 mx-10 shadow-lg z-10">
              {" "}
              {/* Removed rounded-lg */}
              <div>
                <div className="font-semibold text-4xl my-5 text-gray-800">
                  Pricing Tiers
                </div>
                {priceData !== undefined && priceData !== null &&  <PriceGridCards data={priceData} />}
                {/* Using the new component */}
              </div>
              <div className="mt-16">
                {" "}
                {/* Increased margin-top for separation */}
                <div className="font-semibold text-4xl my-8 text-gray-800">
                  Payment Plan
                </div>
                <div>
                  <PaymentProgress prices={paymentPlanData} />{" "}
                  {/* Using the new component */}
                </div>
              </div>
            </div>
          </div>
          <div className="w-[80%] lg:w-[40%] mx-auto mt-8 relative z-40">
            <a target="_blank" href={programme?.Value?.bookingLink}>
              <ButtonComponent
                type={"book"}
                name={"Register"}
                className={"h-24 text-center !px-5 text-3xl"}
              />
            </a>
          </div>
          {/* Content above overlay */}
        </div>

        <div className="my-24">
          <div className="mb-16 text-5xl text-center uppercase font-semibold text-color-primary-dark2">
            Other Programs
          </div>

          <div className="flex flex-col lg:flex-row space-x-0 lg:space-x-10 space-y-5 lg:space-y-0">
            {programmes !== undefined &&
              programmes !== null &&
              programmes?.results?.length > 0 &&
              programmes?.results?.map((program, index) => (
                <div
                  key={index}
                  onClick={() => navigate(`/programmes/${program?.id}`)}
                >
                  <ProgrammeComponent program={program} />
                </div>
              ))}
          </div>
        </div>
      </div>
    </ClientLayout>
  );
};

export default ProgrammeDetail;
